// This consists of public routes
import { lazy } from "react";

const LandingPage = lazy(() => import("../components/navigation/landing"));
const InitiativeFAQs = lazy(
  () => import("../components/LSV/InitiativeDetails/FAQs")
);
const FAQ = lazy(() => import("../components/faq"));
const ForgetPasswordForm = lazy(
  //@ts-ignore
  () => import("../components/common/forms/ForgetPasswordForm")
);
const LoginForm = lazy(() => import("../components/common/forms/LoginForm"));
//@ts-ignore
const ApplicantSignup = lazy(
  () => import("../components/applicants/auth/signup")
);

const InitiativeDetails = lazy(
  () => import("../components/LSV/InitiativeDetails")
);

// used for authenticated and public
const ProgramDetails = lazy(
  () => import("../components/programs/programDetails")
);
const ProgramTestimonials = lazy(
  () => import("../components/programs/testimonials")
);

const PublicProgramList = lazy(
  () => import("../components/programs/programsList/PublicProgramList")
);
const ProgramSurveys = lazy(
  //@ts-ignore
  () => import("../components/programs/programSurveys")
);
const ProductList = lazy(
  () => import("../components/programs/programsList/ProductList")
);
const Checkout = lazy(
  () => import("../components/programs/programsList/ecommerce/Checkout")
);
const PaymentConfirmation = lazy(
  () =>
    import("../components/programs/programDetails/sections/PaymentConfirmation")
);
//@ts-ignore
const CommunityCenterSignup = lazy(
  () => import("../components/community-service/auth/signup/index")
);
//@ts-ignore
const ParentSignup = lazy(() => import("../components/parents/auth/signup"));
//@ts-ignore
const EventDetails = lazy(() => import("../components/events/EventDetails"));
const EventsList = lazy(() => import("../components/events/EventsList"));
//@ts-ignore
const CompanySignup = lazy(() => import("../components/companies/auth/signup"));

const VerifyEmail = lazy(() => import("../components/Auth/Unauth/VerifyEmail"));
const ParentalPhotoVideoConsent = lazy(
  () => import("../components/common/PhotoVideoConsent/ParentReview")
);

export const publicRoutes = [
  { path: "accounts", Component: LandingPage, key: "accounts" },
  {
    path: "parent/signup",
    Component: ParentSignup,
    key: "parent-signup",
  },
  {
    path: "company/signup",
    Component: CompanySignup,
    key: "company-signup",
  },
  {
    path: "initiatives/:initiativeID/faq",
    Component: InitiativeFAQs,
    key: "initiatives-list",
  },
  {
    path: "FAQ",
    Component: FAQ,
    key: "faq",
  },

  {
    //TODO: check the arabic
    path: "initiatives/:initiativeID",
    Component: InitiativeDetails,
    key: "initiative-detail",
  },
  {
    path: "community_center/signup",
    Component: CommunityCenterSignup,
    key: "community-center-signup",
  },
  {
    path: "programs/:programID/surveys/:surveyID",
    Component: ProgramSurveys,
    key: "program-survey",
  },
  {
    path: "programs/:programID",
    Component: ProgramDetails,
    key: "program-detail",
  },
  {
    path: "programs/:programName/testimonials",
    Component: ProgramTestimonials,
    key: "program-testimonails",
  },
  {
    path: "/",
    Component: PublicProgramList,
    key: "programs",
  },
  {
    path: "products",
    Component: ProductList,
    key: "products",
  },
  {
    path: "checkout",
    Component: Checkout,
    key: "checkout",
  },
  {
    path: "confirmation",
    Component: PaymentConfirmation,
    key: "confirmation",
  },
  {
    path: "event-details/:slug",
    Component: EventDetails,
    key: "event-details",
  },
  {
    path: "events",
    Component: EventsList,
    key: "events",
  },

  // New auth (non login routes) behind account/
  {
    path: "account/password/reset/key/:token",
    Component: ForgetPasswordForm,
    key: "account-password/reset",
  },
  {
    path: "login/:userType",
    Component: LoginForm,
    key: "login",
  },
  {
    path: "applicant/signup",
    Component: ApplicantSignup,
    key: "applicant-signup",
  },
  {
    path: "account/verify-email/:key",
    Component: VerifyEmail,
    key: "verifyEmail",
  },
  {
    path: "photo-video-consent/:token",
    Component: ParentalPhotoVideoConsent,
    key: "photo-video-consent",
  },
];
